import { createSelector } from '@reduxjs/toolkit';
import { functionsWithEmployeeNames } from './functions-with-employee-names';

export const singleFunctionsWithEmployeeNames = createSelector(
  functionsWithEmployeeNames,
  (
    functions,
  ): {
    uuid: string;
    type: string;
    name: string;
    employees: string[];
  }[] => {
    return functions.filter(function (item) {
      return item.type === 'SINGLE';
    });
  },
);
